import { createContext, useContext, useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { userProfile } from "recoil/atom";
import { useLocation } from "react-router-dom";

const rolesState = {
  "/dashboard/admin-management": {
    isAllowAddAdmin: ["superadmin"],
    isAllowEditAdmin: ["superadmin"],
  },
  "/dashboard/system-balances": {
    isAllowWithdraw: ["superadmin", "admin"],
  },
  "/dashboard/register-email": {
    isAllowAddWhiteList: ["superadmin", "admin"],
    isAllowApprove: ["superadmin", "admin"],
    isAllowReject: ["superadmin", "admin"],
  },
  "/dashboard/merchants": {
    isAllowActive: ["superadmin", "admin"],
    isAllowDeactive: ["superadmin", "admin"],
    isAllowEditFee: ["superadmin", "admin"],
  },
  "/dashboard/charges": {},
  "/dashboard/payments": {},
  "/dashboard/unmatched-payment": {
    isAllowResolve: ["superadmin", "admin"],
    isAllowNotes: ["superadmin", "admin"],
  },
  "/dashboard/widthdrawal-history": {},
  "/dashboard/system-withdraw-history": {},
  "/dashboard/settings/service-fee": {
    isAllowEditServiceFee: ["superadmin", "admin"],
  },
  "/dashboard/settings/crypto-currencies": {
    isAllowCreate: ["superadmin", "admin"],
    isAllowEdit: ["superadmin", "admin"],
  },
  "/dashboard/settings/chains": {
    isAllowCreate: ["superadmin", "admin"],
    isAllowEdit: ["superadmin", "admin"],
  },
  "/dashboard/whitelist-email": {
    isAllowCreate: ["superadmin", "admin"],
    isAllowDelete: ["superadmin", "admin"],
  },
};

const initialRoles = Object.entries(rolesState).reduce((acc, [key, value]) => {
  acc[key] = Object.entries(value).reduce((acc, [key, value]) => {
    acc[key] = false;
    return acc;
  }, {});
  return acc;
}, {});

export const RolesContext = createContext(initialRoles);

export const useRoles = () => useContext(RolesContext);

function RolesProvider(props) {
  const { user } = useRecoilValue(userProfile);
  const { role } = user || {};
  const location = useLocation();

  const [rolesData, setRolesData] = useState(initialRoles);
  useEffect(() => {
    if (!role) {
      return;
    }
    console.log(location);
    setRolesData((prevRole) => ({
      ...prevRole,
      [location.pathname]: {
        ...Object.entries(rolesState[location.pathname] ?? {}).reduce(
          (acc, [key, pageRoles]) => ({
            ...acc,
            [key]: pageRoles.includes(role),
          }),
          {},
        ),
      },
    }));
  }, [role, location]);

  return <RolesContext.Provider value={rolesData} {...props} />;
}

export default RolesProvider;
